import { useEffect } from 'react';
import { AboutStrip } from '@/components/about/AboutStrip';
import { BrandShowcase } from '@/components/brands/BrandShowcase';
import { ContactSection } from '@/components/contact/ContactSection';
import { Hero } from '@/components/hero/Hero';
import { PriceTable } from '@/components/pricing/PriceTable';
import { ServicesGrid } from '@/components/services/ServicesGrid';

export function HomePage() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      // hinnakiri lives inside teenused now
      const target = id === 'hinnakiri' ? 'teenused' : id;
      requestAnimationFrame(() => {
        document.getElementById(target)?.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }, []);

  return (
    <main id="main">
      <Hero />
      <ServicesGrid />
      <PriceTable />
      <BrandShowcase />
      <AboutStrip />
      <ContactSection />
    </main>
  );
}
